import React, { useEffect, useState } from "react";
import "./SoftwareAssociates.css";

const logos = [
  { name: "Tekla", img: "/assets/images/SoftwareAssociates/software1.png" },
  { name: "ETABS", img: "/assets/images/SoftwareAssociates/software2.jpg" },
  { name: "Autodesk", img: "/assets/images/SoftwareAssociates/software3.jpg"},
  { name: "ZWCAD", img: "/assets/images/SoftwareAssociates/software4.png" },
  { name: "STAAD", img: "/assets/images/SoftwareAssociates/software2.jpg" },
];

const SoftwareAssociates = () => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((prev) => (prev + 1) % logos.length);
    }, 2000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="software-section">
      <h2 className="software-title">Software Associates</h2>

      <div className="carousel">
        <div
          className="carousel-track"
          style={{
            transform: `translateX(calc(50% - ${(active + 0.5) * 200}px))`,
          }}
        >
          {logos.map((logo, index) => (
            <div
              key={index}
              className={`logo-card ${index === active ? "active" : ""}`}
            >
              <img src={logo.img} alt={logo.name} />
            </div>
          ))}
        </div>
      </div>

      <p className="software-desc">
        We partner with globally trusted engineering software to deliver precision,
        speed, and industry-compliant designs.
      </p>
    </section>
  );
};

export default SoftwareAssociates;
